import { FC, useContext, useEffect, useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Box } from '@mui/material';
import { getStyles } from './languageSelection.styles';
import { LocalizationContext } from '@context/LocalizationContext';
import { LanguageChangeIcon } from '@icons/LanguageChangeIcon';
import { InvestigationContext } from '@context/InvestigationContext';
import { ExpandMore } from '@mui/icons-material';
import { useAnalytics } from '@hooks/useAnalytics';
import { REFINE_ANALYTICS_EVENTS } from '@/types/RefineAnalyticsEvents';

export const LanguageSelection: FC = () => {
	const { setLanguage, LanguageCode } = useContext(LocalizationContext);
	const { investigationDetails } = useContext(InvestigationContext);
	const [languageSelectValue, setLanguageSelectValue] = useState(LanguageCode);
	const { trackRefineEvent } = useAnalytics();

	// Update the language when the language selection is changed
	useEffect(() => {
		if (investigationDetails) {
			let investigationLanguage = investigationDetails.lang;
			// Handle the case where the language is 'en' instead of 'en-US': Old investigations
			if (!investigationLanguage || investigationLanguage === 'en') {
				investigationLanguage = 'en-US';
			}
			setLanguageSelectValue(investigationLanguage);
		}
	}, [investigationDetails]);

	const handleChange = (event: SelectChangeEvent) => {
		setLanguage(event.target.value);
		setLanguageSelectValue(event.target.value);
		trackRefineEvent(REFINE_ANALYTICS_EVENTS.LANGUAGE_CHANGED, { language: event.target.value });
	};
	const { select } = getStyles();
	return (
		<Box display={'flex'} alignItems={'center'}>
			<LanguageChangeIcon />
			<Select
				IconComponent={ExpandMore}
				data-cy={'pqLanguageSelect'}
				sx={select}
				value={languageSelectValue}
				onChange={handleChange}>
				<MenuItem data-cy={'pqLanguageSelectEnglishOption'} value={'en-US'}>
					English
				</MenuItem>
				<MenuItem data-cy={'pqLanguageSelectSpanishOption'} value={'es-ES'}>
					Español
				</MenuItem>
			</Select>
		</Box>
	);
};
